export const HOME_POLL_INTERVAL_MS = 5 * 60_000;

/**
 * No poll while the document is hidden; the visibility refetch catches up when it shows again.
 * Leave `notifyOnNetworkStatusChange` off so a later poll updates figures in place instead of
 * flashing a loading state.
 */
export const HOME_POLL_OPTIONS = {
  pollInterval: HOME_POLL_INTERVAL_MS,
  skipPollAttempt: (): boolean => typeof document !== 'undefined' && document.hidden,
};
